import React from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/FirstWorkerSuccessModal.css';
import celebrationImage from '../../../../../../../assets/illustration/successIcon.png';

const FirstWorkerSuccessModal = ({ onClose, onAddAnother, onViewList }) => {
  return (
    <div className="success-popup-overlay">
      <div className="success-popup-card">
        <div className="success-popup-header">
          <h2>🎉 Worker Added!</h2>
          <button className="success-popup-close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="success-popup-body">
          <img src={celebrationImage} alt="Success Icon" className="success-popup-image" />
          <p>Your first worker has been added successfully.</p>
          <p>You can now mark attendance and log payments.</p>
        </div>

        <div className="success-popup-footer">
          <button className="success-popup-add-btn" onClick={onAddAnother}>+ Add Another</button>
          <button className="success-popup-cancel-btn" onClick={onViewList}>Go to Worker List</button>
        </div>
      </div>
    </div>
  );
};

export default FirstWorkerSuccessModal;
